// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__7fhD0","content":"GlobalSearch_content__3cYtK"};